import type { IAddressInstallationStandard } from "@nju/data-access-portal-wwt";
import type { IScope } from "@nju/scope";

export const generateInstallationStandardTexts = ({
  installationStandard = "notDefined",
  isSfh,
  variant,
}: {
  installationStandard: IAddressInstallationStandard | undefined;
  isSfh: boolean | undefined;
  variant: IScope;
}) => {
  if (!isSfh || !installationStandard) {
    return "";
  }

  const portalInstallations = {
    stdAir:
      "Pod Twoim adresem instalacja zostanie wykonana linią napowietrzną. Skontaktujemy się z Tobą, aby potwierdzić jej datę.",
    nonStdAir:
      "Pod Twoim adresem instalacja zostanie wykonana linią napowietrzną. Może jednak zaistnieć konieczność wcześniejszej wizyty Technika - wówczas skontaktujemy się z Tobą, aby potwierdzić datę instalacji.",
    stdGround:
      "Pod Twoim adresem instalacja zostanie wykonana linią doziemną. Skontaktujemy się z Tobą, aby potwierdzić jej datę.",
    nonStdGround:
      "Pod Twoim adresem instalacja zostanie wykonana linią doziemną. Może jednak zaistnieć konieczność wcześniejszej wizyty Technika - wówczas skontaktujemy się z Tobą, aby potwierdzić datę instalacji.",
    notDefined:
      "Technik może się z Tobą kontaktować celem ustalenia dogodnego terminu instalacji.",
  };

  const salesInstallations = {
    stdAir:
      "Pod tym adresem instalacja zostanie wykonana linią napowietrzną. Technik skontaktuje się z klientem i potwierdzi jej datę.",
    nonStdAir:
      "Pod tym adresem instalacja zostanie wykonana linią napowietrzną do budynku. Jednak wcześniej może zaistnieć konieczność przeprowadzenia wizji lokalnej/budowy przyłącza do budynku. Technik skontaktuje się z klientem i potwierdzi datę instalacji.",
    stdGround:
      "Pod tym adresem instalacja zostanie wykonana linią doziemną. Technik skontaktuje się z klientem i potwierdzi datę instalacji.",
    nonStdGround:
      "Pod tym adresem instalacja zostanie wykonana linią doziemną do budynku. Jednak wcześniej może zaistnieć konieczność przeprowadzenia wizji lokalnej/budowy przyłącza do budynku. Technik skontaktuje się z klientem i potwierdzi datę instalacji.",
    notDefined:
      "Technik może się kontaktować z klientem celem potwierdzenia terminu instalacji.",
  };

  return variant === "portal"
    ? portalInstallations[installationStandard]
    : salesInstallations[installationStandard];
};
